import { createTheme } from '@mui/material/styles';

/**
 * Tema Abitare In — LOOK LEGACY (scelta esplicita dell'utente).
 * Valori ESATTI ripresi da homeconfigurator/repos/frontend/src/styles/theme.js
 * (Material-UI v4 → riportati qui su MUI v5).
 */
export const legacyColors = {
  black: '#000',
  white: '#fff',
  orange: '#F08219',
  green: '#76B830',
  red: '#991914',
  yellow: '#F0D80A',
  grey1: '#F0EFEE',
  grey2: '#BEBCBB',
  brownGrey1: '#F8F5F3',
  brownGrey2: '#EBE4E0',
  brownGrey3: '#C5BAAE',
  disabledGrey: '#E5E5E5',
  disabledGreyText: '#5E5E5E',
  textDark: '#262626',
  textDarker: '#1d1d1b',
} as const;

declare module '@mui/material/styles' {
  interface Theme {
    custom: { colors: typeof legacyColors };
  }
  interface ThemeOptions {
    custom?: { colors: typeof legacyColors };
  }
}

export const theme = createTheme({
  custom: {
    colors: legacyColors,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 1024, // iPad
      md: 1200, // Small desktop
      lg: 1366, // iPad Pro
      xl: 1920, // Desktop
    },
  },
  palette: {
    primary: {
      main: legacyColors.orange,
      contrastText: legacyColors.white,
    },
    secondary: {
      main: legacyColors.green,
      contrastText: legacyColors.white,
    },
    background: {
      default: legacyColors.white,
      paper: legacyColors.grey1,
    },
    error: {
      main: legacyColors.red,
    },
    success: {
      main: legacyColors.green,
    },
    warning: {
      main: legacyColors.yellow,
      contrastText: legacyColors.textDark,
    },
    text: {
      primary: legacyColors.textDark,
      secondary: legacyColors.disabledGreyText,
    },
    divider: legacyColors.brownGrey2,
  },
  typography: {
    fontFamily: '"p22-underground", sans-serif',
    h1: { fontFamily: '"miller", serif', fontSize: '2.5rem', fontWeight: 400, letterSpacing: '0.01em' },
    h2: { fontFamily: '"miller", serif', fontSize: '2rem', fontWeight: 400, letterSpacing: '0.01em' },
    h3: { fontFamily: '"miller", serif', fontSize: '1.5rem', fontWeight: 400, letterSpacing: '0.01em' },
    h4: { fontSize: '1.25rem', fontWeight: 500 },
    body1: { fontSize: '1rem', lineHeight: 1.7 },
    body2: { fontSize: '0.875rem', lineHeight: 1.6, color: legacyColors.disabledGreyText },
    button: { textTransform: 'none', fontWeight: 500, letterSpacing: '0.02em' },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        'html, body, #root': {
          height: '100%',
        },
        'body, button, input': {
          fontFamily: '"p22-underground", sans-serif',
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&:before': {
            backgroundColor: 'transparent',
          },
          '&.Mui-expanded': {
            margin: 0,
          },
          '&.Mui-disabled': {
            backgroundColor: legacyColors.brownGrey1,
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          flexDirection: 'column',
          padding: 0,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '12px 32px',
        },
        containedPrimary: {
          backgroundColor: legacyColors.orange,
          '&:hover': {
            backgroundColor: '#D5730F',
          },
        },
        containedSecondary: {
          backgroundColor: legacyColors.green,
          '&:hover': {
            backgroundColor: '#659F29',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: `1px solid ${legacyColors.brownGrey2}`,
        },
      },
    },
  },
});
